/* eslint-disable camelcase */
import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
  objects: {},
  runsheetsByDate: {},
}

export const getters = {}

export const mutations = {
  SET_RUNSHEETS(state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
      if (!objects[key].deleted_at) {
        // Remove the '__typename' field that gets added by GraphQL
        delete objects[key].__typename
        // Stage the update so we can just do one Vue.set
        updatedObjects[objects[key].id] = objects[key]
      } else if (state.objects.hasOwnProperty(objects[key].id)) {
        // Immediately delete the object
        Vue.delete(state.objects, objects[key].id)
      }
    }
    state.objects = {
      ...updatedObjects,
    }
  },
  SET_RUNSHEET(state, objects) {
    state.runsheetsByDate = objects
  },
  SET_RUNSHEETS_UPCOMING(state, objects) {
    state.runsheetsUpcoming = objects
  },
}

export const actions = {
  init({ commit, rootState }) {
    // Initialise the GraphQL client
    graphqlClient = createGraphQLClient(rootState)
  },
  async getPolyline({commit}, { latOne, latTwo, lonOne, lonTwo }) {
    try {
      const response = await graphqlClient.query({
        query: gql`
          query getPolyline(
            $latOne: Float
            $latTwo: Float
            $lonOne: Float
            $lonTwo: Float
          ) {
            getPolyline(
              latOne: $latOne
              latTwo: $latTwo
              lonOne: $lonOne
              lonTwo: $lonTwo
            )
          }
        `,
        variables: {
          latOne: latOne,
          latTwo: latTwo,
          lonOne: lonOne,
          lonTwo: lonTwo,
        },
      })

      return response
    } catch (ex) {
      console.error(ex)
    }
  },
  async runsheetByVehicleId({ commit }, { vehicleId, date } = {}) {
    try {
      const response = await graphqlClient.query({
        query: gql`
          query runsheetByVehicleId($Vehicle: ID!, $Date: String) {
            runsheetByVehicleId(vehicle_id: $Vehicle, date: $Date) {
              id
              vroom_schedule_id
              vehicle_id
              route_steps
              geometry
              collections {
                id
                client {
                  client_name
                }
                site {
                  address
                  suburb
                  postcode
                  lat
                  lon
                }
                binsToCollect {
                  id
                  bin {
                    id
                    description
                    name
                    capacity
                    itemcode
                    price
                  }
                }
                expected_collection_time
              }
              date
              created_at
              updated_at
              deleted_at
            }
          }
        `,
        variables: { Vehicle: vehicleId, Date: date },
      })
      commit('SET_RUNSHEET', response.data.runsheetByVehicleId)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async runsheetById({ commit }, { id } = {}) {
    try {
      await graphqlClient.query({
        query: gql`
          query runsheetById($id: ID!) {
            runsheetById(id: $id) {
              id
              vehicle{
                id
                number_plate
              }
              collections {
                id
                actual_amount_collected
                client {
                  client_name
                }
                site {
                  address
                  suburb
                  postcode
                  lat
                  lon
                }
                binsToCollect {
                  id
                  bin {
                    id
                    description
                    name
                    capacity
                    itemcode
                    price
                  }
                }
                expected_collection_time
              }
              date
              created_at
              updated_at
              deleted_at
            }
          }
        `,
        variables: { id: id },
      }).then((response) => {
        if(response && response.data && response.data.runsheetById){
          console.log('response.data.runsheetById!! ', response.data.runsheetById)
          commit('SET_RUNSHEET', response.data.runsheetById)
          return response.data.runsheetById
        }
      })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async runsheetByNumberPlate({ commit }, { numberPlate, date } = {}) {
    try {
      const response = await graphqlClient.query({
        query: gql`
          query runsheetByNumberPlate($Plate: String!, $Date: String) {
            runsheetByNumberPlate(number_plate: $Plate, date: $Date) {
              id
              vroom_schedule_id
              vehicle_id
              route_steps
              geometry
              collections {
                id
                client {
                  client_name
                }
                binsToCollect {
                  id
                  bin {
                    id
                    description
                    name
                    capacity
                    itemcode
                    price
                  }
                }
                site {
                  address
                  suburb
                  postcode
                  lat
                  lon
                }
                expected_collection_time
              }
              date
              created_at
              updated_at
              deleted_at
            }
          }
        `,
        variables: { Plate: numberPlate, Date: date },
      })
      commit('SET_RUNSHEET', response.data.runsheetByNumberPlate)
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async createRunsheet({ commit, dispatch }, { vehicle_id, date } = {}) {
    try {
      await graphqlClient.mutate({
        mutation: gql`
          mutation CreateRunsheet($vehicle_id: ID, $date: String) {
            createRunsheet(runsheet: { vehicle_id: $vehicle_id, date: $date }) {
              id
            }
          }
        `,
        variables: { vehicle_id: vehicle_id, date: date },
      })
      // dispatch('getCollectionsByServiceId')
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async generateSchedule({ commit, dispatch }, { date } = {}) {
    try {
      await graphqlClient
        .mutate({
          mutation: gql`
            mutation GenerateSchedule($date: String) {
              generateSchedule(date: $date) {
                id
              }
            }
          `,
          variables: { date: date },
        })
        .then(res => {
          // console.log(res)
        })
      // dispatch('getCollectionsByServiceId')
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },

  async getRunsheetsByDate({ commit }, { date } = {}) {
    try {
      return await graphqlClient
        .query({
          query: gql`
            query getRunsheetsByDate($date: String) {
              runsheetsByDate(date: $date) {
                id
                vroom_schedule_id
                route {
                  id
                  name
                }
                vehicle {
                  id
                  number_plate
                }
                route_steps
                geometry
                collections {
                  id
                  service {
                    service_bins {
                      bin {
                        id
                        name
                        description
                        capacity
                      }
                    }
                  }
                  binsToCollect {
                    id
                    bin {
                      id
                      description
                      name
                      capacity
                      itemcode
                      price
                    }
                  }
                  client {
                    id
                    client_name
                  }
                  site {
                    id
                    address
                    state
                    suburb
                    state
                    country
                    postcode
                    phone
                    mobile
                  }
                  completed
                  service_type {
                    id
                    description
                    name
                  }
                  expected_collection_time
                  collection_date
                  order
                  notes
                }
                date
                created_at
                updated_at
                deleted_at
              }
            }
          `,
          variables: { date: date },
        })
        .then(response => {
          commit('SET_RUNSHEETS', response.data.runsheetsByDate)
          return response.data.runsheetsByDate
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
  async getUpcomingRunsheets({ commit }, { date } = {}) {
    try {
      return await graphqlClient
        .query({
          query: gql`
            query getUpcomingRunsheets($date: String) {
              runsheetsUpcoming(date: $date) {
                id
                vroom_schedule_id
                route {
                  name
                }
                vehicle {
                  id
                  number_plate
                }
                route_steps
                geometry
                collections {
                  id
                  service {
                    service_bins {
                    id
                    bin_id
                      bin {
                        id
                        name
                        description
                        capacity
                      }
                    }
                  }
                  binsToCollect {
                    id
                    bin {
                      id
                      description
                      name
                      capacity
                      itemcode
                      price
                    }
                  }
                  client {
                    id
                    client_name
                  }
                  site {
                    id
                    address
                    state
                    suburb
                    state
                    country
                    postcode
                    phone
                    mobile
                    contact_name
                    trading_name
                  }
                  completed
                  service_type {
                    id
                    description
                    name
                  }
                  expected_collection_time
                  collection_date
                  order
                  notes
                }
                date
                created_at
                updated_at
                deleted_at
              }
            }
          `,
          variables: { date: date },
        })
        .then(response => {
          commit('SET_RUNSHEETS_UPCOMING', response.data.runsheetsUpcoming)
          return response.data.runsheetsByDate
        })
    } catch (ex) {
      console.error(ex)
      throw ex
    }
  },
}
